import request from '@/utils/request';
import Resource from '@/api/resource';

class GameIdResource extends Resource {
  constructor() {
    super('game');
  }

  /** 通过应用ID获取游戏ID接口 */
  getGameIDApi(data) {
    return request({
      url: `${this.uri}/getByPromotedObjectId`,
      method: 'GET',
      params: data,
    });
  }

  /** 获取游戏应用列表 */
  getGameChannelAppsApi(params) {
    return request({
      url: `${this.uri}/channelApps`,
      method: 'GET',
      params,
    });
  }
}

export { GameIdResource as default };
